import React from 'react';
import {IconProps} from './types';

export const Share = ({width, height, color, ...props}: IconProps) => {
    return (
        <svg {...props} width={width} height={height} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="39" height="39" rx="7.5" stroke={color}/>
            <path
                d="M20.25 14.75V21.125M22.5 16.25L20.25 14L18 16.25M15 20V23.75C15 24.1478 15.158 24.5294 15.4393 24.8107C15.7206 25.092 16.1022 25.25 16.5 25.25H24C24.3978 25.25 24.7794 25.092 25.0607 24.8107C25.342 24.5294 25.5 24.1478 25.5 23.75V20"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
